import { render, staticRenderFns } from "./ConnoisseurInfo.vue?vue&type=template&id=3364c2fa&scoped=true&"
import script from "./ConnoisseurInfo.vue?vue&type=script&lang=js&"
export * from "./ConnoisseurInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConnoisseurInfo.vue?vue&type=style&index=0&id=3364c2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3364c2fa",
  null
  
)

export default component.exports